import { ArrowRight } from 'lucide-react'
import type { ReactNode } from 'react'
import { Link } from 'react-router'
import { Hint } from 'shared/components/section'
import { Button } from 'shared/components/ui/button'

/** A figure's label with its explanation behind an «i» — only when there is one. */
export function LabelWithHint({ label, hint }: { label: string; hint: string }): ReactNode {
	if (!hint) return label
	return (
		<span className='inline-flex items-center gap-1'>
			{label}
			<Hint>{hint}</Hint>
		</span>
	)
}

/** A section's way to the page where its work is done, at the right of its title. */
export function GoTo({ to, label, testId }: { to: string; label: string; testId: string }) {
	return (
		<Button asChild variant='ghost' size='sm'>
			<Link to={to} data-testid={testId}>
				{label}
				<ArrowRight data-icon='inline-end' />
			</Link>
		</Button>
	)
}
